import { extendedProductRules, UserType } from '@webc/meeseeks-ui-sdk';

export const getMaxTotalPassengersCountByCountryCode = (
  departureCountryCode: string | undefined,
  arrivalCountryCode: string | undefined,
  userType: UserType,
) => {
  const countryId = `${departureCountryCode}-${arrivalCountryCode}`;
  const maxTotalPassengersCount =
    extendedProductRules[countryId] && extendedProductRules[countryId][userType]?.maxTotalAmount;

  return maxTotalPassengersCount;
};
